<div class="selection-dialog">
  <nz-spin [nzSpinning]="loading">
      <nz-table class="declaration-table" [nzData]="filteredData" [nzScroll]="{ y: '250px' }" [nzFrontPagination]="false" nzSize="middle">
        <thead>
          <tr *ngIf="this.controlType !== 'hscode'">
            <th>CODE</th>
            <th>Description</th>
          </tr>
          <tr *ngIf="this.controlType === 'hscode'">
            <th nzWidth="15%">CODE</th>
            <th nzWidth="70%">Description</th>
            <th nzWidth="15%" *ngIf="this.controlType === 'hscode'">UOM</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredData">
            <td>{{ item.code }}</td>
            <td>{{ item.label }}</td>
            <td *ngIf="this.controlType === 'hscode'">{{ item.uom }}</td>
          </tr>
        </tbody>
      </nz-table>
      <div *ngIf="!filteredData.length" class="no-data no-data-msg">
        No data available
      </div>
      <nz-pagination *ngIf="total > 0 && !isInvalid" [(nzPageIndex)]="pageIndex" [nzTotal]="total" [nzPageSize]="pageSize" (nzPageIndexChange)="onPageChange($event)" class="pagination-right"></nz-pagination>
  </nz-spin>
</div>
